import { useQuery } from '@tanstack/react-query'
import {
	type GetMMParkingLotListingsParams,
	httpGetMMParkingLotListings
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const MM_PARKING_LOT_QUERY_KEY = 'mm-parking-lot'

export const useGetMMParkingLotListings = (
	params: GetMMParkingLotListingsParams = {}
) =>
	useQuery({
		queryKey: [MM_PARKING_LOT_QUERY_KEY, params],
		queryFn: () => httpGetMMParkingLotListings(params)
	})
